import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";

const TeachersDetail = () => {
  const { id } = useParams();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/data/teachersData.json")
      .then(res => res.json())
      .then(data => {
        const found = data.find(t => t._id.toString() === id);
        setTeacher(found);
        setLoading(false);
      });
  }, [id]);

  return (
    <div className="container mx-auto my-12">

      {/* Page Title (same style feeling) */}
      <h1 className="text-3xl font-bold text-center uppercase">
        Teacher <span className="text-primary">Profile</span>
      </h1>

      {loading ? (
        <div className="flex justify-center mt-8">
          <span className="loading loading-spinner loading-lg text-primary"></span>
        </div>
      ) : teacher ? (
        <div className="max-w-3xl mx-auto mt-8 bg-base-100 shadow-xl rounded-lg p-8">

          <div className="flex flex-col md:flex-row gap-8 items-center">
            
            {/* Image */}
            <img
              src={teacher.image}
              alt={teacher.name}
              className="w-60 rounded-lg shadow-md"
            />

            {/* Info */}
            <div className="space-y-3">
              <h2 className="text-2xl font-bold">{teacher.name}</h2>
              <p className="text-gray-500">{teacher.designation}</p>
              <p><span className="font-semibold">Department:</span> {teacher.dept}</p>
              <p><span className="font-semibold">Email:</span> {teacher.email}</p>
              <p><span className="font-semibold">Educational Qualification:</span> {teacher.qualification}</p>
              <p><span className="font-semibold">Research Interest:</span> {teacher.research}</p>
            </div>

          </div>

          {/* Back Button */}
          <div className="text-center mt-8">
            <Link
              to={`/teachers/${teacher.dept}`}
              className="btn btn-primary"
            >
              Back to Department
            </Link>
          </div>

        </div>
      ) : (
        <p className="text-center mt-10">Teacher not found.</p>
      )}
    </div>
  );
};

export default TeachersDetail;
